// extracted by mini-css-extract-plugin
export var truncate = "_y-0";